/**
 * Base class for all mm objects
 *
 * @class Obj
 */
export class Obj {
}
//# sourceMappingURL=object.js.map